<template>
    <div class="footer-section">
        <div class="footer-container">
            <div class="footer-left">
                <img :src="a3" alt="Efisense" class="footer-logo">
                <p class="footer-description fuente-nova">
                    Diseñamos experiencias exepcionales para marcas lideres que buscan una conexión auténtica con sus clientes.
                </p>
                <div class="footer-contact">
                    <a href="https://efisense.com" target="_blank" class="contact-link fuente-nova">efisense.com</a>
                    <a href="mailto:hola@efisense.com" class="contact-link fuente-nova">hola@efisense.com</a>
                    <a href="tel:+529999306053" target="_blank" class="contact-link fuente-nova">+52 (999) 930.60.53</a>
                </div>
                <div class="footer-social">
                    <a href="https://www.facebook.com/efisense" target="_blank" class="social-link">
                        <img :src="a30" alt="Facebook" class="social-icon">
                        <span>Facebook</span>
                    </a>
                    <a href="https://www.instagram.com/efisense/" target="_blank" class="social-link">
                        <img :src="a29" alt="Instagram" class="social-icon">
                        <span>Instagram</span>
                    </a>
                    <a href="https://wa.me/529996435584" target="_blank" class="social-link">
                        <img :src="a47" alt="WhatsApp" class="social-icon">
                        <span>WhatsApp</span>
                    </a>
                </div>
                <p class="footer-address fuente-nova">
                    Efisense Media, Tablaje 33796 Calle 34 S/N, Komchén, Mérida, YUC 97302, Mexico
                </p>
            </div>
            <div class="footer-right">
                <article v-for="section in landings" :key="section.name" class="footer-landing-section">
                    <h3 class="landing-title fuente-nova2">{{ section.name }}</h3>
                    <p v-for="landing in section.landings" :key="landing.relativePath" class="landing-link fuente-nova" @click="pushLanding(landing)">
                        {{ landing.name }}
                    </p>
                    <template v-if="section.subs && section.subs.length > 0">
                        <article v-for="subSection in section.subs" :key="subSection.name" class="footer-landing-section">
                            <h3 class="landing-title fuente-nova2">{{ subSection.name }}</h3>
                            <p v-for="landing in subSection.landings" :key="landing.relativePath" class="landing-link fuente-nova" @click="pushLanding(landing)">
                                {{ landing.name }}
                            </p>
                        </article>
                    </template>
                </article>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FooterRewardNew',
    data() {
        return {
            a3: require('@/assets/images/a46.png'),
            a29: require('@/assets/images/a29.svg'),
            a30: require('@/assets/images/a30.svg'),
            a47: require('@/assets/images/a47.svg'),
            landings: []
        }
    },
    mounted() {
        this.getLandings()
    },
    methods: {
        getLandings() {
            const config = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                }
            }
            fetch('https://mikele.efisen.se/apiCRM/Landing/getList', config)
                .then(response => response.json())
                .then(data => {
                    if (data.code && data.code === 200) {
                        this.landings = data.data
                    } else {
                        this.landings = []
                        console.error('Error fetching landings:', data.message)
                    }
                })
                .catch(error => {
                    console.error('Error fetching landings:', error)
                })
        },
        pushLanding(landing) {
            this.$router.push({
                path: `/l/${landing.relativePath}`,
                state: landing
            })
        }
    }
}
</script>

<style lang="css" scoped>
.footer-section {
    width: 100vw;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 80px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    background-color: #272727;
}

.footer-container {
    max-width: 1800px;
    width: 100%;
    display: flex;
    gap: 60px;
}

.footer-left {
    max-width: 30%;
    color: white;
}

.footer-logo {
    width: 200px;
    height: auto;
}

.footer-description {
    font-size: 18px;
    margin: 30px 0;
    padding-left: 20px;
    line-height: 1.4;
}

.footer-contact {
    display: flex;
    gap: 20px;
    padding-left: 20px;
    flex-wrap: wrap;
}

.contact-link {
    color: white;
    font-size: 12px;
    font-weight: bold;
    text-decoration: none;
}

.contact-link:hover {
    opacity: 0.7;
}

.footer-social {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 30px;
    padding-left: 20px;
}

.social-link {
    display: flex;
    align-items: center;
    gap: 15px;
    color: white;
    text-decoration: none;
    font-size: 18px;
    font-weight: bold;
}

.social-link:hover {
    opacity: 0.7;
}

.social-icon {
    width: 18px;
    height: 18px;
}

.footer-address {
    font-size: 13px;
    margin-top: 30px;
    padding-left: 20px;
    line-height: 1.4;
}

.footer-right {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    gap: 40px;
    padding-top: 80px;
}

.footer-landing-section {
    color: white;
    min-width: 200px;
}

.landing-title {
    font-size: 18px;
    margin: 0 0 15px 0;
}

.landing-link {
    font-size: 14px;
    margin: 0 0 8px 30px;
    cursor: pointer;
    transition: color 0.3s ease;
}

.landing-link:hover {
    color: gray;
}

/* Mobile */
@media (max-width: 768px) {
    .footer-section {
        padding: 100px 20px 40px 20px;
        min-height: auto;
    }

    .footer-container {
        flex-direction: column;
        gap: 40px;
    }

    .footer-left {
        max-width: 100%;
    }

    .footer-logo {
        display: none;
    }

    .footer-description {
        font-size: 14px;
        padding-left: 10px;
        margin: 0 0 20px 0;
    }

    .footer-contact {
        flex-direction: row;
        gap: 15px;
        padding-left: 10px;
    }

    .contact-link {
        font-size: 11px;
    }

    .footer-social {
        flex-direction: row;
        gap: 20px;
        margin-top: 20px;
        padding-left: 10px;
    }

    .social-link span {
        display: none;
    }

    .social-icon {
        width: 24px;
        height: 24px;
    }

    .footer-address {
        font-size: 11px;
        padding-left: 10px;
        margin-top: 20px;
        padding-top: 20px;
        border-top: 1px solid rgba(255, 255, 255, 0.2);
    }

    .footer-right {
        padding-top: 0;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
    }

    .footer-landing-section {
        min-width: auto;
    }

    .landing-title {
        font-size: 14px;
    }

    .landing-link {
        font-size: 12px;
        margin-left: 10px;
        font-weight: normal;
    }
}
</style>
